const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    const boop = navigator;
    boop.serviceWorker.register('/service-worker.js');
  }
};

export default registerServiceWorker;
